import { NgModule } from '@angular/core';
// Pipes
import { EscapeHtmlPipe } from './escape-html/escape-html.pipe';
import { TimeLeftPipe } from './time-left/time-left.pipe';
import { StatePipePipe } from './statePipe/state-pipe.pipe';

@NgModule({
    declarations: [
        EscapeHtmlPipe,
        TimeLeftPipe,
        StatePipePipe,
    ],
    exports: [
        EscapeHtmlPipe,
        TimeLeftPipe,
    ]
  })
  
  export class PipesModule { }